module.exports = __webpack_public_path__ + "img/embalse.b58ab87f.png";